import { render, staticRenderFns } from "./auth-form.html?vue&type=template&id=717b75b8&scoped=true&"
import script from "./auth-form.js?vue&type=script&lang=js&"
export * from "./auth-form.js?vue&type=script&lang=js&"
import style0 from "./auth-form.scss?vue&type=style&index=0&id=717b75b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717b75b8",
  null
  
)

export default component.exports